import React from 'react';
import { StripSquare } from '../../plot/components/StripSquare';
import { useEventTimestamp } from '../../plot/hooks/useEventTimestamp';
import * as colors from '../../utils/colors';

interface Props {
  onset: number;
  offset: number;
  setMoving: (timestamp: number) => void;
  setBoundary: (boundary: 'start' | 'end') => void;
  cursor: 'grabbing' | 'ew-resize' | undefined;
}

export const RulerSquare: React.FC<Props> = ({
  onset,
  offset,
  setBoundary,
  setMoving,
  cursor,
}) => {
  const getTimestamp = useEventTimestamp();

  const updateByBoundary = (
    event: React.MouseEvent<SVGRectElement>,
    boundary: 'start' | 'end',
  ) => {
    event.preventDefault();
    if (event.button !== 0) {
      return;
    }
    setBoundary(boundary);
  };

  const startMoving = (event: React.MouseEvent<SVGRectElement>) => {
    event.preventDefault();
    if (event.button !== 0) {
      return;
    }
    const timestamp = getTimestamp(event);
    setMoving(timestamp);
  };

  return (
    <StripSquare
      data-testid='ruler'
      onset={onset}
      offset={offset}
      cursor={cursor}
      main={{
        fill: colors.rulerBackground,
        onMouseDown: startMoving,
      }}
      leftHandle={{
        onMouseDown: (event) => updateByBoundary(event, 'start'),
      }}
      rightHandle={{
        onMouseDown: (event) => updateByBoundary(event, 'end'),
      }}
    />
  );
};
